<div class="batches-index-header">
  <div class="batches-index-header-block">
    <span class="batches-index-header-title">{{
      'BATCH_MAILING.TITLE' | translate
    }}</span>
    <a
      target="_blank"
      aria-labelledby="batch-mailing-title"
      href="https://belpost.by/biznesu/Drugiyeuslugi/Oformleniyepartionnykhpoc"
    >
      {{ 'BATCH_MAILING.LINK_TO_RECOMMENDATIONS' | translate }}
    </a>
  </div>

  <div class="head-btns-contained">
    <button
      type="button"
      class="button button--sm button--filled button--shadow"
      (click)="create()"
    >
      {{ 'BATCH_MAILING.BATCHES_TAB.CREATE_NEW_BATCH' | translate }}
    </button>

    <!--<label class="button button&#45;&#45;sm button&#45;&#45;filled button&#45;&#45;shadow button-parse">
    <input class="d-none"
      type="file"
      accept=".xlsx, .xls,"
      (change)="parse($event)" />
    <span [inlineSVG]="'assets/img/icons/upload.svg'"></span>
    <span>
      {{ 'BATCH_MAILING.BATCHES_TAB.DOWNLOAD_XLSX' | translate }}
    </span>
  </label>-->
  </div>

  <app-main-tabs></app-main-tabs>
</div>

<div @fadeIn>
  <app-filters
    [data]="(batches | async).data"
    (removeChange)="remove()"
    [selected]="selected"
    (duplicateChange)="duplicate($event)"
    (searchChange)="search($event)"
  ></app-filters>

  @if (!isLoading) {
    <div>
      <app-paginator
        [items]="batches | async"
        [localStorageKey]="'batch_items_per_page'"
        [allowedPageSizes]="pageSizes"
        [pageSizeItemKey]="'BATCH_MAILING.BATCHES_TAB.PAGINATION_ITEM_KEY'"
        (pageChange)="pageChanged($event)"
      ></app-paginator>
      @if ((batches | async)?.data?.length) {
        <section class="batches-index-main">
          @if (batches | async; as batches) {
            @for (batch of batches.data; track batch) {
              <app-batch-item
                (click)="navigateToViewBatchPage(batch)"
                [item]="batch"
                (toggleSelect)="updateSelection()"
              ></app-batch-item>
            }
          }
        </section>
      } @else {
        <div class="item-placeholder text-center">
          <img src="./assets/img/misc/box.svg" alt="" class="eye-d-none" />
          <p class="text-secondary">
            {{ 'BATCH_MAILING.BATCHES_TAB.NO_BATCHES_FOUND' | translate }}
          </p>
        </div>
      }
      <!--<div class="batches-index-footer">
      <button class="button button&#45;&#45;sm button&#45;&#45;outlined button&#45;&#45;link-blue button&#45;&#45;shadow d-flex align-items-center"
        type="button"
        (click)="download()">
        {{ 'BATCH_MAILING.BATCHES_TAB.DOWNLOAD_XLSX_BLANK' | translate }}
        <span class="ml-2"
        [inlineSVG]="'assets/img/icons/download-blue.svg'"></span>
      </button>
    </div>-->
    </div>
  }
</div>

@if (isLoading || isLoadingFiles) {
  <div class="text-secondary text-center">
    <div class="spinner-border spinner-border-lg" role="status">
      <span class="sr-only">{{ 'LOADING' | translate }}</span>
    </div>
  </div>
}
